module.exports = __webpack_public_path__ + "img/background_image_mod.4944d7f3.svg";